@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.modal {
  max-width: 780px;
  width: 100%;
  max-height: 100%;
}
.body {
  padding: 10px 20px;

  > * {
    margin-bottom: 16px;
  }
}

.error {
  line-height: 1.5;
}

.loading-indicator {
  height: 100%;
  width: 100%;
  min-height: 100px;
  min-width: 100px;
}

.overview-grid {
  display: grid;
  grid-template-columns: auto auto;
}

.overview-values {
  display: flex;
  padding-right: 10px;
  justify-content: space-between;
}

.shipment-details-grid {
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 8px;
  margin-bottom: 24px;
}

.underline {
  border-bottom: 1px solid @shipperhq--modal--border-color;
}

.header-label {
  color: @shipperhq--modal-label--text-color;
  font-size: 14px;
  line-height: 25px;
}

.label {
  color: @shipperhq--modal-label--text-color;
  font-size: 12px;
  line-height: 18px;
}

.value {
  font-size: 14px;
  line-height: 18px;
}

.header {
  color: @shipperhq--modal--header--text-color;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 12px;
}

.package-details {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.package-information {
  display: flex;
  justify-content: space-between;
  color: @shipperhq--modal--text-color;
  font-size: 14px;
  text-align: right;
  width: 25%;
}
